"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DirectAnswerBlock() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>();
  const {
    ref: hairlineRef,
    isVisible: hairlineVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: statsRef,
    isVisible: statsVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const stats = [{
    label: "PRECISION",
    value: "0.01MM TOLERANCE"
  }, {
    label: "MATERIAL",
    value: "INDUSTRIAL GRADE"
  }, {
    label: "TURNAROUND",
    value: "AS LOW AS 48 HOUR WINDOW"
  }];
  return <section data-section-id="1032" id="direct-answer-block" className="light bg-background text-foreground py-32 md:py-44 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 right-0 h-px flex items-center bg-border">
        <div className="container mx-auto max-w-[1440px] px-5 md:px-6 lg:px-12 relative w-full">
          <div className="absolute top-1/2 -translate-y-1/2" style={{
          left: "calc((7/12) * 100%)"
        }}>
            <div className="w-1 h-1 rounded-md bg-primary" />
          </div>
        </div>
      </div>

      <div className="container mx-auto max-w-[1440px] px-5 md:px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div className="lg:col-span-7 relative">
            {}
            <div aria-hidden="true" className="absolute pointer-events-none select-none font-serif italic font-light text-muted/10" style={{
            fontSize: "clamp(12rem, 22vw, 22rem)",
            top: "10%",
            right: "-2%",
            lineHeight: 1,
            fontFamily: "Georgia, serif"
          }}>
              02
            </div>

            {}
            <div ref={eyebrowRef} className="font-mono text-[12px] flex items-center gap-3 transition-all duration-700 text-foreground" style={{
            letterSpacing: "0.22em",
            opacity: eyebrowVisible ? 1 : 0,
            transform: eyebrowVisible ? "translateY(0)" : "translateY(16px)",
            transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
          }}>
              <span>02</span>
              <span className="text-muted-foreground">/</span>
              <span>§ 02 — OUR MANUFACTURING STANDARDS</span>
            </div>

            {}
            <h2 ref={headingRef} className="font-default font-light mt-16 md:mt-20 relative z-10 transition-all duration-700 text-foreground" style={{
            fontSize: "clamp(2.25rem, 5vw, 4.25rem)",
            lineHeight: 1.02,
            letterSpacing: "-0.02em",
            opacity: headingVisible ? 1 : 0,
            transform: headingVisible ? "translateY(0)" : "translateY(16px)",
            transitionDelay: "80ms",
            transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
          }}>
              Engineering{" "}
              <span className="italic text-primary">
                excellence
              </span>{" "}
              for modern industry
            </h2>

            {}
            <div ref={hairlineRef} className="mt-10 flex items-center gap-0" style={{
            width: "200px",
            opacity: hairlineVisible ? 1 : 0,
            transition: "opacity 600ms ease-out",
            transitionDelay: "200ms"
          }}>
              <div className="h-px flex-1 origin-left bg-border" style={{
              transform: hairlineVisible ? "scaleX(1)" : "scaleX(0)",
              transition: "transform 900ms ease-out",
              transitionDelay: "300ms"
            }} />
              <div className="w-1 h-1 rounded-md ml-px bg-primary" style={{
              transform: hairlineVisible ? "scale(1)" : "scale(0)",
              transition: "transform 200ms cubic-bezier(0.34, 1.56, 0.64, 1)",
              transitionDelay: "1100ms"
            }} />
            </div>

            {}
            <div ref={bodyRef} className="mt-12 max-w-[580px] transition-all duration-700" style={{
            opacity: bodyVisible ? 1 : 0,
            transform: bodyVisible ? "translateY(0)" : "translateY(16px)",
            transitionDelay: "320ms",
            transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
          }}>
              <p className="font-default text-foreground" style={{
              fontSize: "1rem",
              lineHeight: 1.8
            }}>
                <span className="font-serif italic float-left mr-3 mt-2 text-primary" style={{
                fontSize: "96px",
                lineHeight: 0.85,
                fontWeight: 400
              }}>
                  I
                </span>
                ndustrial precision is the backbone of our operations. From high-tolerance laser engraving to complex direct part marking, we ensure every component meets the rigorous demands of modern infrastructure. We strip away the unnecessary, focusing on durability, clarity, and compliance in every mark we create.
              </p>

              <div className="my-10 flex items-center gap-0" style={{
              width: "100%"
            }}>
                <div className="h-px flex-1 bg-border" />
                <div className="w-1 h-1 rounded-md ml-px bg-primary" />
              </div>

              <p className="font-default text-foreground" style={{
              fontSize: "1rem",
              lineHeight: 1.8
            }}>
                Our processes are refined through years of technical expertise. Whether it is phenolic tags for electrical panels or deep-laser etching for aerospace components, our commitment to quality remains absolute. We do not just mark parts; we provide the identification that keeps your systems running safely and efficiently.
              </p>

              <div className="my-10 flex items-center gap-0" style={{
              width: "100%"
            }}>
                <div className="h-px flex-1 bg-border" />
                <div className="w-1 h-1 rounded-md ml-px bg-primary" />
              </div>

              <p className="font-default text-foreground" style={{
              fontSize: "1rem",
              lineHeight: 1.8
            }}>
                Efficiency is our standard. We understand that in your industry, downtime is not an option. Our streamlined production workflow ensures that your submittal packages and custom labels are delivered with the speed and accuracy required to keep your projects on schedule. This is why we are the trusted partner for engineers and contractors.
              </p>
            </div>

            {}
            <div ref={statsRef} className="mt-16 max-w-[580px] transition-all duration-700" style={{
            opacity: statsVisible ? 1 : 0,
            transform: statsVisible ? "translateY(0)" : "translateY(16px)",
            transitionDelay: "480ms",
            transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
          }}>
              {stats.map((stat, i) => <div data-index={i} key={i}>
                  <div className="py-5 grid grid-cols-2 gap-4">
                    <div className="font-mono text-[11px] text-foreground" style={{
                  letterSpacing: "0.22em"
                }}>
                      {stat.label}
                    </div>
                    <div className="font-mono text-[11px] text-primary" style={{
                  letterSpacing: "0.22em"
                }}>
                      · {stat.value}
                    </div>
                  </div>
                  {i < stats.length - 1 && <div className="flex items-center gap-0">
                      <div className="h-px flex-1 bg-border" />
                      <div className="w-1 h-1 rounded-md ml-px bg-primary" />
                    </div>}
                </div>)}
            </div>
          </div>

          {}
          <div className="lg:col-span-5">
            <div ref={imageRef} className="relative transition-all duration-1000" style={{
            opacity: imageVisible ? 1 : 0,
            transform: imageVisible ? "translateY(0)" : "translateY(24px)",
            transitionDelay: "200ms",
            transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
          }}>
              <div className="relative" style={{
              aspectRatio: "4/5"
            }}>
                {}
                <span aria-hidden="true" className="absolute top-0 left-0 w-3 h-3 border-t border-l z-10 border-foreground" />
                <span aria-hidden="true" className="absolute top-0 right-0 w-3 h-3 border-t border-r z-10 border-foreground" />
                <span aria-hidden="true" className="absolute bottom-0 left-0 w-3 h-3 border-b border-l z-10 border-foreground" />
                <span aria-hidden="true" className="absolute bottom-0 right-0 w-3 h-3 border-b border-r z-10 border-foreground" />

                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_laser_engraving.png" alt="Industrial laser engraving process on metal component" loading="lazy" decoding="async" className="w-full h-full object-cover grayscale" />
              </div>

              {}
              <p className="font-serif italic mt-6 text-foreground" style={{
              fontSize: "14px",
              lineHeight: 1.6,
              fontWeight: 400,
              maxWidth: "380px"
            }}>
                Precision calibration for high-durability industrial marking.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}